<template>
  <div>
    <div>
      <el-page-header @back="goBack" content="考生成绩统计" style="margin-bottom: 10px">
      </el-page-header>
    </div>
    <div style="margin: 10px 0">
      <el-row>
        <el-col :span="6"><b>考试：{{this.tableData[0].exam_name}} </b></el-col>
        <el-col :span="6"><b>考试时间：{{this.tableData[0].begin_dt}}~{{this.tableData[0].end_dt}} </b></el-col>
        <el-col :span="6"><b>姓名：{{this.tableData[0].student_name}} </b></el-col>
        <el-col :span="6"><b>学号：{{this.tableData[0].student_code}}</b></el-col>
      </el-row>
    </div>
    <el-table border :data="tableData" stripe style="width: 100%">
      <el-table-column   label="序号">
        <template slot-scope="scope">
          {{scope.$index+1}}
        </template>
      </el-table-column>
      <el-table-column prop="subject_name" label="考试" >
      </el-table-column>
      <el-table-column prop="begin" label="考试时间" >
      </el-table-column>
      <el-table-column prop="time" label="耗时" >
      </el-table-column>
      <el-table-column  label="	成绩" >
        <template slot-scope="scope">
          <span v-if="scope.row.invalidSign.paper_count!=0||scope.row.invalidSign.subject_count!=0">
            {{scope.row.score}}
          </span>
          <span v-else>
            {{scope.row.invalidSign.description>0?'无效':'未查到该成绩记录'}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="grade_teacher" label="评价老师" >
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <i class="el-icon-search" @click="handleEdit(scope.row)"></i>
        </template>
      </el-table-column>
    </el-table>
    <!-- v-if="pageform.total>pageform.pageSize" -->

    <div style="text-align: right;margin-top:20px">

      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.per_page" @pagination="getData"/>

    </div>

  </div>
</template>

<script>
    import Pagination from '../../components/Pagination'
    export default {
        components: { Pagination },
  props: {

  },
  data() {
    return {
        total:0,
        dialogType:'new',
        dialogVisible:false,
        tableData: [],
        examInfo:{},
        listQuery: {
            page: 1,
            per_page:20
        },
    };
  },
  computed: {

  },
  created() {
    this.getData();
  },
  methods: {
      goBack(){
          this.$router.back();
      },
    getData() {
      this.$http.getStudentScoreDetail( this.$route.query)
        .then(res => {
          this.tableData = res.data.data.data;
            this.total = res.data.data.total;
        })
        .catch(err => {
          console.log(err);
        })
    },
      handleEdit(scope) {
        this.$router.push({name:'scoreResult',query:{id:scope.result_id}})
      },
  },
};
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/page/statisticsManage/studentScoreDetail.vue